<template>
  <div :id="componentId" class="sp1-top-banner-fixed" :style="wrapperStyle">
    <div class="sp1-box_33 flex-row" :style="boxStyle">
      <a
        v-for="(item, idx) in navItems"
        :key="idx"
        :class="['sp1-nav-item', { active: activeIndex === idx }]"
        href="javascript:;"
        :style="getItemStyle(idx)"
        @click.prevent="handleClick(idx, item)"
      >
        {{ item.label }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBanner',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_1'
    }
  },
  data() {
    return {
      activeIndex: 0,
      backgroundColor: '#FFFFF0',
      fontColor: 'rgba(51, 51, 51, 1)',
      selectedFontColor: 'rgba(255, 255, 255, 1)',
      selectedModuleColor: 'rgba(9, 79, 70, 1)',
      navItems: [
        { label: '专题介绍', type: 1, value: 'top' },
        { label: '系列活动', type: 1, value: 'module_4' },
        { label: '大会亮点', type: 1, value: 'module_5' },
        { label: '大会嘉宾', type: 1, value: 'module_6' },
        { label: '大会议程', type: 1, value: 'module_7' },
        { label: '大会地址', type: 1, value: 'module_8' },
        { label: '大会主持', type: 1, value: 'module_9' },
        { label: '核心活动', type: 1, value: 'module_10' },
        { label: '精彩回顾', type: 1, value: 'module_11' },
        { label: '年度盛典', type: 1, value: 'module_12' },
        { label: '组织机构', type: 1, value: 'module_13' },
        { label: '合作品牌', type: 1, value: 'module_14' },
        { label: '媒体合作', type: 2, value: 'https://www.baidu.com' }
      ]
    };
  },
  computed: {
    wrapperStyle() {
      return {
        backgroundColor: this.normalizeColor(this.backgroundColor) + ' !important'
      };
    },
    boxStyle() {
      return {
        backgroundColor: 'transparent !important'
      };
    }
  },
  mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.throttledScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.throttledScroll);
  },
  methods: {
    getItemStyle(idx) {
      const isActive = this.activeIndex === idx;
      return {
        color: isActive ? this.selectedFontColor : this.fontColor,
        backgroundColor: isActive ? this.selectedModuleColor : 'transparent'
      };
    },
    normalizeColor(color) {
      if (typeof color !== 'string') return color;
      return color.replace(/^rgb\(\s*(\d+)\s+(\d+)\s+(\d+)\s*\)$/i, 'rgb($1, $2, $3)');
    },
    handleClick(idx, item) {
      this.activeIndex = idx;
      if (item.type === 2) {
        window.open(item.value, '_blank');
        return;
      }
      if (item.value === 'top') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const el = document.getElementById(item.value);
      if (!el) return;
      const headerOffset = 86;
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    },
    throttledScroll() {
      if (this.scrollTimer) return;
      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;
        this.onScroll();
      }, 100);
    },
    onScroll() {
      const scrollTop = window.pageYOffset;
      const viewportHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const lastAnchorIndex = this.navItems.findIndex(item => item.type === 1 && item.value === 'module_15');
      const isBottom = scrollTop + viewportHeight >= docHeight - 20;
      if (isBottom && lastAnchorIndex !== -1) {
        this.activeIndex = lastAnchorIndex;
        return;
      }
      const headerOffset = 120;
      let activeIndex = 0;
      for (let i = this.navItems.length - 1; i >= 0; i--) {
        const item = this.navItems[i];
        if (item.type !== 1 || item.value === 'top') continue;
        const el = document.getElementById(item.value);
        if (!el) continue;
        const sectionTop = el.getBoundingClientRect().top + window.pageYOffset;
        if (sectionTop - headerOffset <= scrollTop) {
          activeIndex = i;
          break;
        }
      }
      this.activeIndex = activeIndex;
    }
  }
};
</script>

<style scoped>
.sp1-top-banner-fixed {
  position: sticky;
  top: 0;
  width: 2000px;
  margin-left: -300px;
  z-index: 1000;
}

.sp1-box_33 {
  width: 1400px;
  margin: 0 auto;
}

.sp1-image_1,
.sp1-box_33 {
  position: relative;
}

.sp1-nav-item {
  flex: 1;
  height: 86px;
  line-height: 86px;
  font-size: 16px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
  overflow: hidden;
}

.sp1-nav-item:hover {
  opacity: 0.85;
}

.sp1-nav-item.active {
  height: 94px;
  line-height: 94px;
  align-self: center;
}
</style>
